import { ComponentProps } from 'react';

const HealthIdInProcess = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_28249_130865)">
        <path
          d="M108.51 28.0249H40.5945C39.3709 28.0249 38.3789 29.0169 38.3789 30.2405V78.8431C38.3789 80.0667 39.3709 81.0587 40.5945 81.0587H108.51C109.734 81.0587 110.726 80.0667 110.726 78.8431V30.2405C110.726 29.0169 109.734 28.0249 108.51 28.0249Z"
          fill="white"
        ></path>
        <path
          d="M108.508 82.097H40.592C40.1655 82.0966 39.7432 82.0121 39.3493 81.8483C38.9555 81.6846 38.5978 81.4448 38.2967 81.1426C37.9957 80.8405 37.7571 80.4819 37.5948 80.0875C37.4325 79.693 37.3495 79.2704 37.3507 78.8439V30.2413C37.3514 29.3819 37.6932 28.5579 38.3009 27.9502C38.9086 27.3425 39.7326 27.0008 40.592 27H108.508C109.367 27.0008 110.191 27.3425 110.799 27.9502C111.407 28.5579 111.748 29.3819 111.749 30.2413V78.8439C111.75 79.2704 111.667 79.693 111.505 80.0875C111.343 80.4819 111.104 80.8405 110.803 81.1426C110.502 81.4448 110.144 81.6846 109.75 81.8483C109.357 82.0121 108.934 82.0966 108.508 82.097ZM40.592 29.0515C40.2764 29.0515 39.9738 29.1768 39.7506 29.4C39.5275 29.6231 39.4021 29.9258 39.4021 30.2413V78.8439C39.4006 79.0011 39.4302 79.1571 39.4893 79.3028C39.5484 79.4486 39.6358 79.5811 39.7465 79.6929C39.8571 79.8046 39.9888 79.8933 40.1339 79.9538C40.2791 80.0143 40.4348 80.0455 40.592 80.0455H108.508C108.823 80.0455 109.126 79.9201 109.349 79.697C109.572 79.4738 109.698 79.1712 109.698 78.8556V30.2413C109.698 29.9258 109.572 29.6231 109.349 29.4C109.126 29.1768 108.823 29.0515 108.508 29.0515H40.592Z"
          fill="#E3E0DB"
        ></path>
        <path
          d="M38.3789 39.7568V31.7267C38.3951 30.7312 38.8052 29.7827 39.5193 29.089C40.2333 28.3952 41.1933 28.0127 42.1888 28.0252H106.91C107.906 28.0119 108.866 28.3942 109.581 29.0881C110.295 29.782 110.705 30.731 110.72 31.7267V39.7568H38.3789Z"
          fill="#E3E0DB"
        ></path>
        <path
          d="M102.738 46.2051H70.2773V48.2566H102.738V46.2051Z"
          fill="#B5ADA2"
        ></path>
        <path
          d="M102.738 52.4805H70.2773V54.532H102.738V52.4805Z"
          fill="#B5ADA2"
        ></path>
        <path
          d="M65.6732 52.0348C65.4757 53.5197 64.8093 54.9027 63.7712 55.9825C63.0675 56.7117 62.2246 57.2922 61.2924 57.6897C60.3603 58.0871 59.3578 58.2935 58.3445 58.2965C57.3311 58.2995 56.3275 58.0991 55.393 57.7072C54.4585 57.3152 53.6122 56.7397 52.9042 56.0147C52.1636 55.251 51.6055 54.3297 51.2715 53.3197C50.9376 52.3097 50.8365 51.2373 50.9758 50.1827C51.4945 46.2467 55.2282 43.4714 59.2813 43.9989C63.3345 44.5264 66.2036 48.1019 65.6732 52.0348Z"
          fill="#E3E0DB"
        ></path>
        <path
          d="M58.2914 51.0729C59.6526 51.0729 60.7561 50.0036 60.7561 48.6844C60.7561 47.3653 59.6526 46.2959 58.2914 46.2959C56.9301 46.2959 55.8267 47.3653 55.8267 48.6844C55.8267 50.0036 56.9301 51.0729 58.2914 51.0729Z"
          fill="#B5ADA2"
        ></path>
        <path
          d="M63.7713 55.9817C63.0676 56.7109 62.2247 57.2914 61.2926 57.6889C60.3604 58.0864 59.358 58.2927 58.3446 58.2957C57.3313 58.2988 56.3276 58.0984 55.3931 57.7064C54.4586 57.3145 53.6123 56.739 52.9043 56.014C53.9623 53.9039 55.9845 52.4796 58.3144 52.4678C60.6443 52.4561 62.6957 53.8746 63.7713 55.9817Z"
          fill="#B5ADA2"
        ></path>
        <path
          d="M43.3556 46.6113L20.1621 54.4011L22.2839 60.3445C23.2283 62.9654 25.0605 65.1729 27.4625 66.584L27.4097 66.6016L27.4654 66.584C29.5506 67.8255 31.9509 68.4363 34.376 68.3424C34.9473 68.9661 35.3869 69.6988 35.6684 70.4965C35.9533 71.2892 36.071 72.1324 36.0142 72.9729C34.0574 74.3421 32.5558 76.2663 31.7032 78.4972L31.6504 78.5178L31.7032 78.5002C30.7217 81.07 30.6936 83.9064 31.624 86.4951L33.7459 92.4415L56.9423 84.6546L54.8205 78.7082C53.8787 76.0903 52.0523 73.8835 49.6566 72.4688L49.7269 72.4454L49.6536 72.4688C47.5742 71.234 45.1834 70.6235 42.7665 70.7104C42.1879 70.0914 41.7422 69.3604 41.4569 68.5625C41.1716 67.7646 41.0528 66.9167 41.1078 66.0711C43.0554 64.7023 44.5495 62.7826 45.3983 60.5585C45.4222 60.5484 45.4467 60.5396 45.4716 60.5321L45.4012 60.5556C46.3819 57.9846 46.4099 55.1475 45.4803 52.5577L43.3556 46.6113Z"
          fill="#75CAC3"
        ></path>
        <path
          d="M22.6216 56.2188L23.8349 59.6125C25.3002 63.7418 29.2332 66.3707 33.4827 66.5055C34.4159 66.5129 35.3258 66.7974 36.097 67.3228C36.8682 67.8483 37.4659 68.591 37.8143 69.4567C37.9139 69.7175 38.0106 69.9842 38.1074 70.2509C38.3164 70.837 38.5118 71.4163 38.6935 71.9888C39.2844 73.8823 39.269 75.9131 38.6495 77.7974L34.6931 90.0096L54.6745 83.3013L43.7401 76.0478C42.0616 74.9502 40.758 73.3664 40.0035 71.5082C39.7847 70.9591 39.5717 70.3965 39.3646 69.8201C39.2679 69.5534 39.1771 69.2896 39.0891 69.0288C38.8075 68.1506 38.803 67.2071 39.0762 66.3262C39.3494 65.4454 39.887 64.67 40.616 64.1052C42.1942 62.8283 43.358 61.1117 43.9599 59.1729L22.6216 56.2188Z"
          fill="#355D60"
        ></path>
        <path
          d="M44.2908 44.1297L18.0278 52.9478L18.6808 54.8925L44.9438 46.0745L44.2908 44.1297Z"
          fill="#4F9493"
        ></path>
        <path
          d="M57.9094 82.2693L31.6465 91.0874L32.2995 93.0322L58.5624 84.2141L57.9094 82.2693Z"
          fill="#4F9493"
        ></path>
        <path
          d="M81.0272 63.5977H52.9043V65.6491H81.0272V63.5977Z"
          fill="#E3E0DB"
        ></path>
        <path
          d="M81.0272 68.5713H52.9043V70.6228H81.0272V68.5713Z"
          fill="#E3E0DB"
        ></path>
        <path
          d="M16.9847 57.9847L9 58.5767L9.15168 60.6225L17.1364 60.0306L16.9847 57.9847Z"
          fill="#5BAFA9"
        ></path>
        <path
          d="M18.529 63.8245L11.313 67.1909L12.1803 69.05L19.3964 65.6836L18.529 63.8245Z"
          fill="#5BAFA9"
        ></path>
        <path
          d="M21.5294 68.0006L16.7271 74.2119L18.35 75.4667L23.1524 69.2554L21.5294 68.0006Z"
          fill="#5BAFA9"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_28249_130865">
          <rect
            width="102.75"
            height="66.0343"
            fill="white"
            transform="translate(9 27)"
          ></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

export default HealthIdInProcess;
